/**
 * @file 带遮罩大图
 * @author wangzhuang
 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './index.less';

export default class ShadeImg extends Component {
    static propTypes = {
        href: PropTypes.string,
        imgSrc: PropTypes.string,
        imgAlt: PropTypes.string,
        title: PropTypes.string,
        text: PropTypes.string

    };

    render() {
        const {href, imgSrc, imgAlt, title, text} = this.props;
        return (
            <div className={'shade-img'}>
                <a href={href} className={'pr'}>
                    <img
                        src={imgSrc}
                        width={'100%'}
                        alt={imgAlt}/>
                    <div className={'shade-hint'}>
                        <div className={'shade-title'}>
                            {title}
                        </div>
                        <div className={'title-text'}>
                            {text}
                        </div>
                    </div>
                </a>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ShadeImg/index.js